module.exports = __webpack_public_path__ + "img/L48-panama.30dffc2b.png";